import React from 'react';
import { FiInfo } from 'react-icons/fi';
import DiscoveryTooltip from 'DiscoveryTooltip';

/**
 * An explanation behind an info icon. A real <button>, so it takes keyboard focus and the
 * tooltip opens on focus as well as hover; `help` doubles as the accessible name.
 */
const HelpIcon = ({ help, testId, placement = 'right', size = '14px', className }) => (
  <DiscoveryTooltip placement={placement} text={help}>
    <button type='button' className={`sg-help${className ? ` ${className}` : ''}`} aria-label={help} data-testid={testId}>
      <FiInfo size={size} aria-hidden='true' />
    </button>
  </DiscoveryTooltip>
);

export default HelpIcon;
